import React from 'react';
import { Result } from 'antd-mobile';
import './Result.css';

const NoResult = () => {

    return (
        <Result
            title={'Tu n\'as aucun live à venir'}
            message={'Ajoute une équipe/club en favoris afin de voir ses matchs à venir et ses matchs passés. Avec Live Score tu peux t\'inscrire en tant que Live Scorer et commenter en direct les matchs de ton équipe/club favorite.'}
            className='ls_no-result'
            buttonText="Ajouter une équipe"
            buttonType="ghost"
            onButtonClick={() => window.postMessage(JSON.stringify({action: 'addTeamsOrClubs', parameters: {}}), '*')}
        />
    )
};

export default NoResult;